export default function IconTest({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <rect
        x="27.2739"
        y="5"
        width="12.2637"
        height="33.8594"
        rx="1.66667"
        transform="rotate(45 27.2739 5)"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path d="M20 15L26.6667 21.6667" stroke="currentColor" strokeWidth="2" />
      <path
        d="M16.6665 18.3333L23.3332 25"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
}
